import { render, staticRenderFns } from "./perfilEmpresarial.vue?vue&type=template&id=20af6d2d&"
import script from "./perfilEmpresarial.vue?vue&type=script&lang=js&"
export * from "./perfilEmpresarial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports